import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installActiveTenantFetch } from './lib/api/activeTenant'

// Every request to the dialer carries the tenant this tab is working in
// (X-Act-As-Tenant). Installed before the first render so no request, the
// first /api/me included, goes out without it. See lib/api/activeTenant.ts.
installActiveTenantFetch()

// SPEC PX-6 R2 (Unit P) — register the owned web-push service worker once, behind
// a feature guard so unsupported browsers degrade cleanly to email/in-app (no
// native app). The subscribe flow (usePushSubscription) waits for this
// registration before fetching the VAPID public key + subscribing.
if ('serviceWorker' in navigator && 'PushManager' in window) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // A registration failure must never break the app — push is additive.
      console.warn('Service worker registration failed:', err)
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
